import Mav from "../../Assets/MAV.png";
import blog from "../../Assets/Blogg.png";
import Funtoy from "../../Assets/FunToy.png";
import cfileader from "../../Assets/cfileader.png";
import encode from "../../Assets/encoder.png";
import fontC from "../../Assets/fontC.png";
import Tresurehunt from "../../Assets/Tresurehunt.png";
import giffi from "../../Assets/giffi.jpg";
import ai_sums from "../../Assets/ai_sums.png";
import simple_CRUD_app from "../../Assets/simple_CRUD_app.png";
import pizza_menu from "../../Assets/pizza_menu.jpg";
import Step_App from "../../Assets/Step_App.jpg";
import Far_Away from "../../Assets/Far_Away.jpg";
import quiz from "../../Assets/Quiz_app.jpg";
import atomic_blog from "../../Assets/atomic_blog.png";
import worldWise from "../../Assets/World_wise.png";
import Italian from "../../Assets/Italian_pizza.png";

// import najeeb_logo from "../../Assets/najeeb.jpg";

export const data = [
  {
    name: "Project MAV [Live]",
    description:
      "A custom CMS and Admin Dashboard where 100k patients, volunteers data is maintained for different camps all over India.",
    link: "http://mahilaarogyavikas.org/",
    image: Mav,
    tec: ["Node JS", "React JS", "Express JS", "MongoDB"],
  },
  {
    name: `Ecommerce App [Live] `,
    description:
      "The Italian Pizza Co. is a personalized pizza ordering! Enter name, explore menu, add to cart, checkout with address, and enjoy confirmation. ",
    link: "https://najeebs-pizza-ecommerce-store-gewke34ql-nmohd.vercel.app/",
    image: Italian,
    tec: [
      "React JS",
      "Redux/Toolkit",
      "React Router 6.4 ",
      "Vite",
      "Tailwind CSS",
    ],
  },
  {
    name: `World Wise App [LIve]`,
    description:
      "A single page app (SPA) world map that tracks your footsteps into every city you can think of. Never forget your wonderful experiences, and show your friends how you have wandered the world.",
    link: "https://11-worldwise.vercel.app/",
    image: worldWise,
    tec: ["React JS", "Context API", "useReducer", "Vite", "Leaflet"],
  },

  {
    name: `Article Summarizer OpenAI GPT-4 API [LIve]`,
    description:
      "Simplify your reading with Summize, an open-source article summarizer that transforms lengthy articles into clear and concise summaries",
    link: "https://summarize-app-using-ai-ot28.vercel.app/",
    image: ai_sums,
    tec: ["React JS", "Redux RTK Query", "Tailwind CSS", "Vite"],
  },
  {
    name: "Blog App using Context API  [Live]",
    description:
      "Learned Context API.Context provides a way to pass data through the component tree without having to pass props down manually at every level.",
    link: "https://atomic-blog-bi1unmk9b-nmohd.vercel.app/",
    image: atomic_blog,
    tec: ["React", "Context API", "Vite"],
  },
  {
    name: "Personal Blog Site  [Live]",
    description:
      "Personal blog site integrated with Contentful dahboard. CRUD operations are done through Contentful API's.",
    link: "https://my-blog-nmohd.vercel.app/",
    image: blog,
    tec: ["React"],
  },
  {
    name: "The React Quiz App  [Live]",
    description:
      "Quiz app using react useReduce hook. Created github api and fetched data using fetch method. Added timer and progress bar to show the progress of the quiz. The whole quiz app was developed to practice useReducer hook which replaces the useState hook. useReducer hook gives advance features like centralizing the whole logic in the reducer function.Play the quiz and test your knowledge of react. ALL THE BEST.",
    link: "https://quiz-app-six-smoky.vercel.app/",
    image: quiz,
    tec: ["React"],
  },
  {
    name: "Tasky",
    description:
      "Tasky is a full-fledged Web App that reminds you about your task via emails and mobile messaging build on MERN Stack.",
    link: " https://github.com/Nmohd/Tasky-App",
    image: giffi,
    tec: ["Node JS", "React JS", "Express JS", "MongoDB"],
  },
  {
    name: "Full stack crud app",
    description: "A simple full stack CRUD app using redux toolkit",
    link: "https://github.com/Nmohd/Full-stack-CRUD-App",
    image: simple_CRUD_app,
    tec: [
      "Node JS",
      "React JS",
      "Express JS",
      "MongoDB",
      "Redux Toolkit",
      "Vite",
    ],
  },

  {
    name: "Travel List App [Live]",
    description:
      "Very Simple React app to practice states and CRUD operations. ",
    link: "https://najeebs-travel-list.vercel.app/",
    image: Far_Away,
    tec: ["React"],
  },
  {
    name: "Very Simple Step App [Live]",
    description: "Very Simple React app to practice useState hook. ",
    link: "https://step-app-ablr.vercel.app/",
    image: Step_App,
    tec: ["React"],
  },
  {
    name: "React Single Page App [Live]",
    description:
      "Simple React Single Page app where I learned basics of React like props, ternary operator and conditional rendering.",
    link: "https://pizza-menu-liar.vercel.app/",
    image: pizza_menu,
    tec: ["React"],
  },

  {
    name: "CFI Leaderboard",
    description:
      "A Dynamic Leaderboard which fetches data from the google sheets using Sheets API and display the Rankings.",
    link: "https://github.com/Nmohd/CFI-Leaderboard-master",
    image: cfileader,
    tec: ["Javascript", "Embeded javascript (EJS)"],
  },
  {
    name: "Treasure Hunt Game",
    description:
      "A game where the user tries to find the treasure. built using JS DOM.",
    link: "https://game-iota.vercel.app/",
    image: Tresurehunt,
    tec: ["Javascript"],
  },
  {
    name: "Base64 Converter",
    description:
      "Do you have to deal with Base64 format? Then this site is perfect for you! Use our super handy online tool to encode or decode your data.",
    link: "https://base64-converter-ui.vercel.app/",
    image: encode,
    tec: ["Javascript"],
  },

  {
    name: "Font Convertor",
    description:
      "A Font Convertor built using HTML, CSS, JS DOM. It converts the style of given input string.",
    link: "https://fontconverter.vercel.app/",
    image: fontC,
    tec: ["Javascript"],
  },
  {
    name: "Fun Toy",
    description:
      "First ever app hosted on Vercel. Simple Toy which makes sounds on clicked over animals.",
    link: "https://for-fun-chi.vercel.app/",
    image: Funtoy,
    tec: ["Javascript"],
  },
];
